import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";

const LanguageSwitcher = ({ handleLangChange }) => {
  return (
    <div className="language-switcher">
      <ul className="d-flex flex-row justify-content-center px-5">
        <li className="d-block">
          <Button color="link" onClick={() => handleLangChange("de")}>
            DE
          </Button>
        </li>
        <li className="d-block">
          <Button color="link" onClick={() => handleLangChange("en")}>
            EN
          </Button>
        </li>
      </ul>
    </div>
  );
};

LanguageSwitcher.propTypes = {
  handleLangChange: PropTypes.func.isRequired,
};

export default LanguageSwitcher;
